// Funding portal pricing tiers — shared across funding pages, comparison, apply

export const PLANS = {
  ai_report: {
    id: "ai_report",
    name: "AI Funding Report",
    price: "$139",
    cadence: "one-time",
    headline: "One-time comprehensive funding analysis.",
    tagline: "Start with clarity.",
    cta: "Get My Report",
    features: [
      "Initial AI funding report",
      "Full personal credit analysis",
      "Business credit assessment",
      "Funding Readiness Paydex Score",
      "Personalized action plan",
      "Lender recommendations",
      "PDF download — business credit-worthiness analysis",
    ],
  },
  pro: {
    id: "pro",
    name: "WealthFirst PRO",
    price: "$45",
    cadence: "per month",
    annualPrice: "$365",
    annualCadence: "per year",
    annualSavings: "save ~32%",
    headline: "Ongoing funding strategy & membership support.",
    tagline: "Stay the course.",
    cta: "Start PRO",
    features: [
      "Everything in AI Report",
      "Monthly AI-powered updated reports",
      "Progress tracking dashboard",
      "Continuously updated lender matching",
      "Priority email support",
      "Training videos & guides",
      "Newsletters: wealth building, preservation, stewardship",
      "Cancel recurring membership anytime",
      "Downgrade from AutoPilot anytime",
    ],
  },
  autopilot: {
    id: "autopilot",
    name: "WealthFirst AutoPilot",
    price: "$91",
    cadence: "per month",
    trialNote: "7-day free trial",
    headline: "Full credit-building automation. Most popular, best value.",
    tagline: "Rocket-success velocity.",
    cta: "Start 7-Day Free Trial",
    featured: true,
    features: [
      "Everything in WealthFirst PRO",
      "7-day free trial",
      "Revocable Business Trust setup & fiduciary guidance",
      "Trust document templates",
      "Automatic qualified-vendor reminders",
      "Credit bureau monitoring",
      "Score-change alerts",
      "Funding opportunity alerts",
      "NAICS risk scanning",
      "DUNS / SBFE / CDFI compliance checks",
      "Downgrade to WealthFirst PRO anytime",
    ],
  },
};

// Full comparison matrix — each feature row has a column for each plan
export const COMPARISON = [
  { feature: "Initial AI funding report", ai_report: true, pro: true, autopilot: true },
  { feature: "Personal credit analysis", ai_report: true, pro: true, autopilot: true },
  { feature: "Business credit assessment", ai_report: true, pro: true, autopilot: true },
  { feature: "Personalized action plan", ai_report: true, pro: true, autopilot: true },
  { feature: "Lender recommendations", ai_report: true, pro: true, autopilot: true },
  { feature: "PDF download", ai_report: true, pro: true, autopilot: true },
  { feature: "Monthly updated reports", ai_report: false, pro: true, autopilot: true },
  { feature: "Progress tracking dashboard", ai_report: false, pro: true, autopilot: true },
  { feature: "Updated lender matching", ai_report: false, pro: true, autopilot: true },
  { feature: "Priority email support", ai_report: false, pro: true, autopilot: true },
  { feature: "Training videos & guides", ai_report: false, pro: true, autopilot: true },
  { feature: "Annual billing option (save ~32%)", ai_report: false, pro: true, autopilot: true },
  { feature: "Revocable Business Trust setup & fiduciary guidance", ai_report: false, pro: false, autopilot: true },
  { feature: "Trust document templates", ai_report: false, pro: false, autopilot: true },
  { feature: "Automatic vendor reminders", ai_report: false, pro: false, autopilot: true },
  { feature: "Credit bureau monitoring", ai_report: false, pro: false, autopilot: true },
  { feature: "Score-change alerts", ai_report: false, pro: false, autopilot: true },
  { feature: "Funding opportunity alerts", ai_report: false, pro: false, autopilot: true },
  { feature: "NAICS risk scanning", ai_report: false, pro: false, autopilot: true },
  { feature: "DUNS / SBFE / CDFI compliance checks", ai_report: false, pro: false, autopilot: true },
];

export const SOCIAL_LINKS = {
  facebook: "https://facebook.com/wealthfirstinctv",
  instagram: "https://instagram.com/profitwealthfirst",
  youtube: "https://www.youtube.com/@wealthfirstincTV",
  linktree: "https://linktr.ee/wealthfirstinc",
  shoes: "https://www.aliveshoes.com/wealth-first-inc-1",
};

// Map UI plan ids to backend plan enum
export const PLAN_TO_API = {
  ai_report: "ai_report",
  pro_monthly: "pro_monthly",
  pro_annual: "pro_annual",
  autopilot: "autopilot",
};
